import { uniqueId } from 'lodash';
import { useEffect, useRef } from 'react';

import type { EventTypesEventIdsMap } from '@swf/sports/providers/LiveDataProvider';
import { useLiveData } from '@swf/sports/providers/LiveDataProvider';

const useScoreboardPolling = (eventTypesEventIdsMap?: EventTypesEventIdsMap): void => {
  const uniqueIdRef = useRef(uniqueId());
  const { dispatch } = useLiveData();

  useEffect(() => {
    if (eventTypesEventIdsMap) {
      dispatch({
        type: 'SET_EVENTS',
        payload: {
          id: uniqueIdRef.current,
          events: eventTypesEventIdsMap
        }
      });
    }
  }, [dispatch, eventTypesEventIdsMap]);

  useEffect(
    () => () => {
      dispatch({
        type: 'REMOVE_EVENTS',
        payload: {
          id: uniqueIdRef.current
        }
      });
    },
    [dispatch]
  );
};

export default useScoreboardPolling;
